<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }} <b-badge variant="success" class="border-radius">NEW</b-badge></h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/new-reimbursement/history-reimbursement"
              >Paid Reimbursement</router-link
            ></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
      <b-col md="6" class="mt-3 text-right">
        <b-button
          @click="exportPaidCsv"
          v-b-tooltip.hover.top
          title="Download to CSV"
          variant="info"
          class="btn-download float-right"
          ><font-awesome-icon icon="download"
        /></b-button>
      </b-col>
    </b-row>
    <div class="border-bottom mb-3" />
    <div v-if="isLoading">
      <b-card>
      <div class="text-center" style="height: 15vh; margin: 10% auto;">
        <b-spinner type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
      </div>
      </b-card>
    </div>
    <div v-else>
      <b-form class="mt-3 mx-2">
        <b-row class="">
          <b-col md="12 mb-3 pl-0">
            <table class="table-bordered" cellpadding="5">
              <thead>
              <tr class="px-3">
                <th width="160">No Request</th>
                <th>Employee</th>
                <th>Category</th>
                <th width="240">Description</th>
                <th>Approved By</th>
                <th>Approved Date</th>
                <th>Paid By</th>
                <th>Paid Time</th>
                <th>Amount</th>
                <th>Status</th>
                <th></th>
              </tr>
              </thead>
              <tbody class="px-4" v-for="(detail , i) in detailReimburs" :key="detail.uuid">
                <tr>
                <td width="160">{{ detail.noRequest !== null ? detail.noRequest : '-' }}</td>
                <td>{{ detail.requestedBy !== null ? detail.requestedBy.name : '-' }}</td>
                <td>
                  {{
                    detail.reimburseCategory !== null ? detail.reimburseCategory.categoryName : '-'
                  }}
                </td>
                <td width="240">{{ detail.note !== null ? detail.note : '-' }}</td>
                <td>{{ detail.approvedBy }}</td>
                <td>{{ getDateTime(detail.approvedTime) }}</td>
                <td>{{ detail.paidBy }}</td>
                <td>{{ getDateTime(detail.paidTime) }}</td>
                <td>{{ dataAccount.account.currency }}  {{ detail.amount }}</td>
                <td>
                  <b-badge :variant="getStatusColor(detail.status)">{{
                    detail.status
                  }}</b-badge>
                </td>
                <td>
                  <a
                  v-b-tooltip.hover.left
                  title="Details"
                  class="btn-op icon-info mr-1"
                  :href="'#' + '/new-reimbursement/history-reimbursement' + '/' + detail.uuid + '/detail'"
                ></a>
                </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        

          <!-- <b-row class="mt-3 mb-3">
            <b-col>
            </b-col>
            <b-col md="12">
              <b-row v-if="model.reimbursePhoto.length === 0">
                <b-col md="3">
                  <p class="text-secondary text-center d-flex border p-5">
                    <i>No Photo Submitted</i>
                  </p>
                </b-col>
              </b-row>
              <td>
                <viewer :images="model.reimbursePhoto">
                <b-row>
                  <b-col md="3" v-for="(src, index) in model.reimbursePhoto" :key="index">
                    <p 
                    width="60" height="60"
                     class="text-secondary text-center border" v-if="src === null">
                      <i width="60" height="60">No Photo Submitted</i>
                    </p>
                    <b-img v-else :src="src.url" class="img-responsive" width="60" height="60" />
                  </b-col>
                </b-row>
              </viewer>
                </td>
            </b-col>
          </b-row> -->

         <!-- <b-col
            md="3 mb-3 pt-4"
            class="border border-radius text-right bg-total"
            style="max-height:80px"
          > -->
            <!-- <h5 style="padding-bottom:15px!important;"> -->
              <!-- <strong
                >Total Amount : {{ dataAccount.account.currency }}
                {{ formatPrice(detail.amount) }}</strong
              > -->
            <!-- </h5> -->
            <!-- <div class="mt-5">
              <h6>Payment Account :</h6>
              <!-- <p>{{ detail.reimburseCategory.journalAccount.journalAccountName }}</p> -->
            <!-- </div> -->
          <!-- </b-col> -->
          <!--<b-col md="12">
                    <b-form-checkbox class="mb-3 float-right" @change="changeFilter(isActive)">This Month Only</b-form-checkbox>
                </b-col>
                <b-col md="12">
                    <b-form-checkbox class="mb-3 float-right">This Month Only</b-form-checkbox>
                </b-col>-->
          <!-- <b-col md="12 p-0">
                    <div class="table-responsive">
                    <table class="table table-hovered table-striped">
                        <thead>
                            <tr>
                                <th scope="col" width="240">Date</th>
                                <th width="100">Type</th>
                                <th width="650">Note</th>
                                <th width="150">Sub Total</th>
                                <th width="50"></th>
                            </tr>
                        </thead>
                        <tbody v-if="reimburseAmountStatsList.length > 0">
                            <tr v-for="(payment, index) in reimburseAmountStatsList" :key="index">
                                <td>{{getDateTime(payment.createdAt)}}</td>
                                <td>{{payment.reimburseType.name}}</td>
                                <td>{{payment.note}}</td>
                                <td>{{ dataAccount.account.currency }} {{formatPrice(payment.amount)}}</td>
                                <td>
                                    <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#/reimbursement/general/' + payment.uuid"></a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="9" class="text-center">there's no data</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </b-col> -->
        </b-row>
         <!-- <b-row class="mt-3 mb-3">
            <h4>Reimbursement Status History</h4>
            <div class="table mt-3">
            <table class="table-bordered table-striped">
              <thead>
                <tr>
                  <th width="120">Status</th>
                  <th width="260">Changed By</th>
                  <th width="460">Note</th>
                  <th width="240">Time</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(history, i) in model.reimbursementHistoryStatusList" :key="history.uuid">
                  <td><b-badge :variant="getStatusColor(history.status)">{{history.status}}</b-badge></td>
                  <td>{{history.changedBy !==null ? history.changedBy : '-'}}</td>
                  <td>{{history.note !==null ? history.note : '-'}}</td>
                  <td>{{getDateTime(history.updatedAt)}}</td>
                </tr>
              </tbody>
            </table>
            </div>
          </b-row> -->
      </b-form>
      
    </div>
      <b-button class="mt-3" @click="goBack" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
      >
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        reimbursement: window.AppConfig.apiUrl + 'reimbursement',
        reimbursementHistoryStatus: window.AppConfig.apiUrl + 'reimbursement-history-status',
        exportPaidReimburs: window.AppConfig.apiUrl + 'export-payment-paid'
      },
      model: {
        noRequest: '',
        requestedBy: {
          uuid: null,
          name: null,
          department: null,
        },
        reimbursementHistoryStatusList: [],
        amount: '',
        paidDate: '',
        paidTime: '',
        paidNote: '',
        startTime: '',
        endTime: '',
        status: '',
        note: '',
        createdAt: '',
        changedBy: '',
        reimburseType: null,
        reimburseCategory: {
          journalAccount: [],
        },
        reimbursement: [],
        reimbursePhoto: '',
        statusValue: '',
        statusText: '',
        statusTime: '',
        statusTextTime: '',
        approvedBy: '',
        destination: '',
        totalMileage: '',
        totalPetrol: '',
        payment: {
          totalAmount: null,
          detailPayment: {
            date: null,
            type: {
              Toll: null,
              Food: null,
              Petrol: null,
              Mileage: null,
            },
          },
        },
      },
      list: {
        listAccount: [],
      },
      tableFilter: {
        status: this.$route.query.status,
        statusreimbursement: null,
        requested_by: this.$route.query.requested_by,
        userRequestedBy: {
          value: null,
        },
        date: null,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
      },
      reimburseAmountStats: {
        field: [],
      },
      totalAmount: 0,
      reimburseAmountStatsList: [],
      detailReimburs: [],
    };
  },
  mounted() {
    this.getDetailReimburse();
    this.getReimburseHistoryStatus()
  },
  methods: {
    getDetailReimburse() {
      this.$http.get(this.apiUrl.reimbursement + '?requested_by=' + this.$route.params.uuid).then((resp) => {
        this.detailReimburs = [],
        this.detailReimburs = resp.data._embedded.reimbursement,
        this.model.noRequest = resp.data.noRequest
        this.model.requestedBy = resp.data.requestedBy.name;
        this.model.paidTime = resp.data.paidTime;
        this.model.note = resp.data.note;
        this.model.noRequest = resp.data.noRequest;
        this.model.reimburseCategory = resp.data.reimburseCategory;
        this.model.reimburseHistory = resp.data.reimburseHistory;
        this.model.amount = resp.data.amount;
        this.model.paidNote = resp.data.paidNote;
        this.model.approvedBy = resp.data.approvedBy;
        this.model.reimbursePhoto = resp.data.reimbursePhoto;
        this.model.status = resp.data.status;
        this.reimburseAmountStats = [];
      })
    },

    getReimburseHistoryStatus(){
      this.$http.get(this.apiUrl.reimbursementHistoryStatus + '?reimburse_uuid=' + this.$route.params.uuid).then((resp) => {
        let histories = resp.data._embedded.reimbursementHistoryStatus
        this.model.reimbursementHistoryStatusList = histories
      })
    },

    exportPaidCsv(){
      let url = this.apiUrl.exportPaidReimburs + '?token=' + this.$store.getters['account/tokens'].access_token + '&requested_by=' + this.$route.params.uuid

      window.open(url);
    },

    goBack() {
      window.goBack(this);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getDateTime (value) {
         if (value !== null) {
             return this.$moment(value).format('YYYY-MM-DD HH:mm A')
         } else {
             return '-'
         }
       },
    getStatusColor(val) {
      switch (val) {
        case 'Approved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Requested':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Rejected':
          return 'danger';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Paid':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>
